import * as React from 'react';
import LicenseInfoContext from './LicenseInfoContext';

/**
 * @ignore - do not document.
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - do not document.
 */
export function LicenseInfoProvider({
  info,
  children
}) {
  return /*#__PURE__*/_jsx(LicenseInfoContext.Provider, {
    value: info,
    children: children
  });
}